import { Updater, AsyncState } from 'widgets-for-react'
import { loadTeamMembers } from './aboutUs.api'

export type URL = string

export type TeamMemberId = number

const sampleTeamMembersODataResponse = [
  {
    Name: 'Gerard',
    Surname: 'Pastwa',
    Age: 44.0,
    CompanyRole: 'CEO',
    ImageURL: 'www.google.com',
    Id: '037c5494-e9f7-4fe0-90e4-75ef67135f64',
    Title: 'Gerard Pastwa',
    Created: '2021-07-26T13:39:22',
    Modified: '2021-07-26T13:39:22'
  }
]

export type TeamMembersODataResponse = typeof sampleTeamMembersODataResponse

type ArrayArg<v> = v extends Array<infer arg> ? arg : never
export type TeamMemberODataResponse = ArrayArg<TeamMembersODataResponse>

export type TeamMember = Pick<TeamMemberODataResponse, 'Id' | 'Age' | 'Name' | 'Surname' | 'CompanyRole' | 'ImageURL'>

export type AboutUsState = {
  teamMembers: AsyncState<Array<TeamMember>>
}

export const initialAboutUsState: AboutUsState = {
  teamMembers: loadTeamMembers()
}

export const aboutUsUpdaters = {
  teamMembers:
    (u: Updater<AsyncState<Array<TeamMember>>>): Updater<AboutUsState> =>
    (s) => ({ ...s, teamMembers: u(s.teamMembers) })
}
